import angular from 'angular';

import DashboardService from './dashboard.service';

export default angular
    .module('application.service.dashboard', [])
    .service('dashboardService', DashboardService);


// WEBPACK FOOTER //
// ./src/application/service/dashboard/index.js